import useMessageStore, {
  EMessageStatus,
  EContentType,
  IMessage,
  EMsgType,
} from '@/store/messageStore';
import { imminer } from '@/assets/proto/msggateway';
import { useWebSocket } from 'ahooks';
import { Message } from '@arco-design/web-react';
import { clone } from '@/utils';
import { sessionConfigCache } from '@/store/userStore';
import { EFaqKnows, useFaq } from './useChat';
import useAppStore from '@/store/appStore';

export enum ReadyState {
  Connecting = 0,
  Open = 1,
  Closing = 2,
  Closed = 3,
}

export default (wsUrl: string) => {
  const messageStore = useMessageStore();
  const { getFaqKnows } = useFaq();
  const isFirstInit = useRef(true);
  const appStore = useAppStore();

  // const messageHistory = useRef<any[]>([]);
  // const [tempMsg, setTempMsg] = useState<WebSocketEventMap['message']>({} as any);

  const sendPingResp = () => {
    const pingRespMessage = imminer.msggateway.MsgEntityToServer.create({
      // msgType: imminer.msggateway.MsgType.create({ messageType: 2 }), // 假设 1 表示某种类型
      msgBody: imminer.msggateway.Join.create({
        content: 'ping',
      }),

      // talkText: imminer.msggateway.Join.create({
      //   content: 'ping',
      // }),
    });

    // 编码消息为二进制格式
    const binaryData = imminer.msggateway.MsgEntityToServer.encode(pingRespMessage).finish();

    return binaryData;
  };

  const handleMessage = (message: WebSocketEventMap['message']) => {
    const { getSessionConfig } = sessionConfigCache();
    const { sessionConfig } = getSessionConfig();

    message?.data?.arrayBuffer?.().then((arrayBuffer: ArrayBuffer) => {
      console.log('原始消息...', arrayBuffer);
      try {
        const uint8Array = new Uint8Array(arrayBuffer);
        const decodedMessage = imminer.msggateway.MsgEntityToFrontEnd.decode(uint8Array);
        console.log('ws发过来的....', decodedMessage);
        // const decodedMessage2 = imminer.msggateway.MsgEntity.decode(uint8Array);
        if (decodedMessage?.msgType === EMsgType.KickOffLineMsgType) {
          Message.info($t('chat_session_status_8'));
          appStore.setIsKickOff();
          return;
        }

        // handle had read message
        const cloneNewList = clone(messageStore.messageList, true);

        if (decodedMessage?.msgType === EMsgType.HasReadReceiptMsgType) {
          const newList = cloneNewList.map((msgItem) => {
            for (
              let i = 0, len = decodedMessage?.hasReadReceiptMsg?.hasReadSeqs?.length;
              i < len;
              i++
            ) {
              const item = decodedMessage?.hasReadReceiptMsg?.hasReadSeqs[i];
              if (msgItem.msgSeq === item && msgItem.senderUid === sessionConfig?.uid) {
                msgItem.isRead = true;
                break;
              }
            }

            return msgItem;
          });

          messageStore.updateMessageList(newList);
          return;
        }

        if (decodedMessage?.msgBody) {
          console.log('decodedMessage?.msgBody...', decodedMessage);
          const tempObj: IMessage = {
            ...decodedMessage?.msgBody,
            msgFromTime: 'current',
            title: decodedMessage?.msgBody?.title,
            senderFaceURL: decodedMessage?.msgBody?.senderFaceURL,
            senderNickname: decodedMessage?.msgBody?.senderNickname,
            status: EMessageStatus.success,
            // clientMsgID: uuidV4() + '-' + Date.now(),
          };

          if (decodedMessage?.msgBody?.msgType === EContentType.video) {
            tempObj.progress = 100;
          }

          if (tempObj.clientMsgID) {
            messageStore.addMessageItem(tempObj);
            // messageStore.setMessageList([...messageStore.messageList, tempObj]);
          }
        }
      } catch (error) {
        console.error('解码失败:', error);
      }
    });
  };

  const { readyState, sendMessage, latestMessage, disconnect, connect } = useWebSocket(wsUrl, {
    onMessage(message) {
      handleMessage(message);
    },

    onOpen() {
      if (import.meta.env?.MODE === 'dev') {
        Message.success('websocket open');
      }
      if (isFirstInit.current) {
        getFaqKnows(EFaqKnows.knows, '');
        isFirstInit.current = false;
      }
    },

    onError(err) {
      if (import.meta.env?.MODE === 'dev') {
        Message.error('websocket closed');
      }
    },

    onClose(e) {
      if (import.meta.env?.MODE === 'dev') {
        Message.error('websocket closed');
      }
    },
  });

  useEffect(() => {
    const timer = setInterval(() => {
      sendMessage?.(sendPingResp());
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return {
    readyState,
    sendMessage,
    latestMessage,
    disconnect,
    connect,
  };
};
